import Outbound from './outbound';

export const OutboundConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : ['super', 'staff', 'outbound'],
    routes  : [
        {
            path     : '/outbound',
            component: Outbound
        }
    ]
};
